import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import {
  isAnyLockAssignedToVisitorGroup,
  isAnyMemberAssignedToGroup,
  isOfficeModeEnabledForVisitorGroup,
  isScheduleSetUpForVisitorGroup
} from 'utils/VisitorGroup/VisitorGroup';
import { FilterAccess, FilterOfficeMode } from './userGroupFilterTypes';

type Params = {
  visitorGroups: VisitorGroup[];
  filterAccess: FilterAccess;
  filterOfficeMode: FilterOfficeMode;
};

export const filterVisitorGroups = ({ visitorGroups, filterAccess, filterOfficeMode }: Params) => {
  let data = visitorGroups;
  if (Object.values(filterAccess).some(Boolean))
    data = data.filter(
      (visitorGroup) =>
        (!filterAccess.noUsers || !isAnyMemberAssignedToGroup(visitorGroup)) &&
        (!filterAccess.noSchedule || !isScheduleSetUpForVisitorGroup(visitorGroup)) &&
        (!filterAccess.noDevices || !isAnyLockAssignedToVisitorGroup(visitorGroup))
    );
  if (filterOfficeMode !== null) {
    if (filterOfficeMode === FilterOfficeMode.Allowed)
      data = data.filter((visitorGroup) => isOfficeModeEnabledForVisitorGroup(visitorGroup));
    if (filterOfficeMode === FilterOfficeMode.NotAllowed)
      data = data.filter((visitorGroup) => !isOfficeModeEnabledForVisitorGroup(visitorGroup));
  }
  return data;
};
